import { Button, ButtonGroup, Card } from "@blueprintjs/core"
import CustomButton from "components/Atoms/CustomButton"
import React, { useCallback, useState } from "react"
import { useNavigate } from "react-router-dom"
import MultipleDemands from "./multiple/MultipleDemands"
import SingleDemands from "./single/SingleDemands"
export default function DemandForm() {
  const [selectedTab, changeSelectedTab] = useState("Single Demand")
  const navigate = useNavigate()

  const handleClick = useCallback(() => navigate(-1), [navigate])

  return (
    <div className="p-3">
      <Card className="p-0">
        <div className="w-full lg:max-w-[80%] mx-auto p-3 flex justify-between items-center">
          <div className="mr-3 flex items-center">
            <CustomButton
              className="mr-3"
              minimal
              icon="arrow-left"
              onClick={handleClick}
            />
            <h6 className="my-0">{selectedTab}</h6>
          </div>

          <ButtonGroup>
            <Button
              intent={selectedTab === "Single Demand" ? "primary" : null}
              icon="document"
              onClick={e => changeSelectedTab("Single Demand")}
              active={selectedTab === "Single Demand"}
              text="Single Demand"
            />
            <Button
              intent={selectedTab === "Multiple Demand" ? "primary" : null}
              icon="duplicate"
              onClick={e => changeSelectedTab("Multiple Demand")}
              active={selectedTab === "Multiple Demand"}
              text="Multiple Demand"
            />
          </ButtonGroup>
        </div>
        {selectedTab === "Single Demand" ? (
          <SingleDemands />
        ) : (
          <MultipleDemands />
        )}
      </Card>
    </div>
  )
}
